
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { EMRService } from 'app/EMR/EMR.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { AuthService } from 'app/auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class imageworkupService {

    
    constructor(public http: HttpClient, public dashboardService: DashboardService,public emrService :EMRService,public opdvisitService:OpdVisitService,public authService:AuthService) {

    }

  getTempaltedata(templateid){
    return this.http.get(this.dashboardService.newbaseUrl +"DoctorWorkUpMaster/GetImageTemplateMasterTranIdBySubSpecialityId/"+templateid+'/'+0);
  }

  insertTemplatedata(data){ 
     return this.http.post(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/InsertImageTemplateMaster", data);  
  }
  uploadDoc(formdata){
    return this.http.post(this.dashboardService.newbaseUrl +"Document/UploadFile",formdata);
  }
  uploadAzureDoc(formdata){
    return this.http.post(this.dashboardService.newbaseUrl +"DocumentUpload/UploadFile",formdata);
  }
  getImagedata(tranid,brachid,folder){
    return this.http.get(this.dashboardService.newbaseUrl +"Document/GetAllFiles/"+tranid+'/'+brachid+'/'+folder);
  }
  getAzureImagedata(tranid,brachid,folder){
    return this.http.get(this.dashboardService.newbaseUrl +"DocumentUpload/GetPatientDocumentDetailByRegIdByBranchIdByDocumentType/"+tranid+'/'+brachid+'/'+folder);
  }
  getRecentTempaltedata(notemplate){
    return this.http.get(this.dashboardService.newbaseUrl +"DoctorWorkUpMaster/GetImageTemplateMasterRecentlyUsedByNoOfRecords/"+notemplate);
  }
  getsaveTemplate(patientid){
    return this.http.get(this.dashboardService.newbaseUrl +"VisitMaster/GetVisitTable/"+patientid +'/'+this.emrService.visitid +'/'+ this.opdvisitService.DoctorIdEmr +'/'+this.authService.Loggeduser.specialityId);
  }
  UpdatePatientDocumentDetail(formdata){
    return this.http.post(this.dashboardService.newbaseUrl +"DocumentUpload/UpdatePatientDocumentDetail",formdata);
  }
  insertIPDImageWorkup(payload){
    return this.http.post(this.dashboardService.newbaseUrl +"IPDWorkup/InsertOtImageDetail",payload);
    
  }
  // insertOPDImageWorkup(payload){
  //   return this.http.post(this.dashboardService.newbaseUrl +"DoctorWorkup/Insertopdimagedetail",payload);
    
  // }
  getOPDImageworkup(regid:any){
    return this.http.get(this.dashboardService.newbaseUrl +"DoctorWorkup/GetopdimagedetailByRegId/"+regid );
  }
  getIPDImageworkup(regid,ipdid,transid){
    return this.http.get(this.dashboardService.newbaseUrl +"IPDWorkup/GetOtImageDetailByRegIdByIPDIdByTranId/"+regid +'/'+ipdid +'/'+ transid);
  }
  insertgetImagepath(payload){
    return this.http.post(this.dashboardService.newbaseUrl +"DocumentUpload/GetDocument",payload);
    
  }
  openBase64InBrowserretune(base64Data: string, mimeType: string) {
    // Decode the Base64 string
    const byteCharacters = atob(base64Data);
    const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
  
    // Create a Blob with the decoded data
    const blob = new Blob([byteArray], { type: mimeType });
  
    // Generate a URL for the Blob
    const blobUrl = URL.createObjectURL(blob);
  
    // Open the Blob URL in a new window or tab
   // window.open(blobUrl);
   
    // Optionally, revoke the URL later to free up resources
   // setTimeout(() => URL.revokeObjectURL(blobUrl), 10000); // Adjust the timeout as needed
    return blobUrl;
  }
  openBase64InBrowser(base64Data: string, mimeType: string, fileName: string): void {
    // Decode the Base64 string
    const byteCharacters = atob(base64Data);
    const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
  
    // Create a Blob with the decoded data
    const blob = new Blob([byteArray], { type: mimeType });
  
    // Check if the browser can render the MIME type
    const canRenderInBrowser = mimeType.startsWith('image/') || mimeType === 'application/pdf' || mimeType.startsWith('text/');
  
    if (canRenderInBrowser) {
      // Generate a URL for the Blob and open it
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl);
  
      // Revoke the URL after a delay
      setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
    } else {
      // If the MIME type isn't supported, force download
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
  
      // Revoke the URL after a delay
      setTimeout(() => URL.revokeObjectURL(link.href), 10000);
    }
  }
  openBase64InDownload(base64Data: string, mimeType: string, fileName: string): void {
    const byteCharacters = atob(base64Data);
    const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    // Create a Blob with the decoded data
    const blob = new Blob([byteArray], { type: mimeType });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      // Revoke the URL after a delay
      setTimeout(() => URL.revokeObjectURL(link.href), 10000);
  }
}